export function createReorderProfilePath(orderId: string): string {
  return `/mypage/order/${orderId}/reorder/profile`
}
export function createReorderPaymentPath(orderId: string): string {
  return `/mypage/order/${orderId}/reorder/payment`
}
